import React, { useState } from 'react';
import Review from '../components/review';
import '../css/Home.css';
import '../css/Service.css';

const LaundryService = () => {
  const [previewSrc, setPreviewSrc] = useState(null);

  const showPreview = (src) => setPreviewSrc(src);
  const hidePreview = () => setPreviewSrc(null);

  return (
    <div className="service-page">
      {previewSrc && (
        <div
          onClick={hidePreview}
          onMouseLeave={hidePreview}
          role="button"
          tabIndex={0}
          style={{
            position: 'fixed',
            inset: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: 'rgba(0,0,0,0.7)',
            zIndex: 2000,
            cursor: 'zoom-out'
          }}
        >
          <img src={previewSrc} alt="Preview" style={{ maxWidth: '92%', maxHeight: '92%', boxShadow: '0 6px 30px rgba(0,0,0,0.6)' }} />
        </div>
      )}

      <div className="service-banner">
        <img src="/laundary_service.jpeg" alt="Laundry Service Banner" className="service-banner-img" onMouseEnter={() => showPreview('/laundary_service.jpeg')} onClick={() => showPreview('/laundary_service.jpeg')} />
        <div className="service-banner-overlay"></div>
        <div className="service-banner-content">
          <h1>Industrial & Healthcare Laundry Solutions</h1>
        </div>
      </div>

      <header className="service-header">
        <h1>Premium Industrial & Healthcare Laundry</h1>
        <p>Clinical-grade textile processing for hospitals, cleanrooms, and industrial facilities.</p>
      </header>

      <section className="service-content">
        <div className="service-content-left">
          <h2>Healthcare & Hospital Laundry Services</h2>
          <p style={{ textAlign: 'justify' }}>
            We provide a comprehensive circular linen management system for healthcare facilities. Every item — from emergency rooms to patient wards — undergoes a rigorous multi-stage decontamination process.
          </p>

          <h3>Key Hospital Items We Manage</h3>
          <ul>
            <li>Patient Bedding: bedspreads, thermal blankets, and hypoallergenic pillowcases.</li>
            <li>Surgical Textiles: scrub suits, surgical gowns, and specialized drapes.</li>
            <li>Patient Apparel: gowns, pyjamas, and robes.</li>
            <li>General Linens: towels, bath mats, and cubicle curtains.</li>
          </ul>

          <h3>Advanced Washing & Disinfection Techniques</h3>
          <p style={{ textAlign: 'justify' }}>
            Our facility utilizes thermal, chemical, and light-based technologies to achieve 99.99% microbial reduction.
          </p>
          <ul>
            <li><strong>Thermal Disinfection:</strong> High-temperature wash cycles (71°C for 25 minutes) to inactivate resistant organisms.</li>
            <li><strong>Dual-Barrier Processing:</strong> Separate "Soiled" and "Clean" zones to prevent cross-contamination.</li>
            <li><strong>pH-Balanced Chemistry:</strong> Hospital-grade detergents and anti-redeposition agents to protect fabrics and skin.</li>
          </ul>

          <h3>The Clean World Innovation: UV-C Sterilization</h3>
          <p style={{ textAlign: 'justify' }}>
            After drying, linens pass through a UV-C sterilization tunnel to provide a final, chemical-free layer of biological safety.
          </p>

          <h3>Specialized Industrial Laundry</h3>
          <p style={{ textAlign: 'justify' }}>
            We launder industrial workwear, cleanroom garments, microfiber mops, and other specialized textiles to meet strict sector requirements.
          </p>

          <h3>Quality Assurance & Tracking</h3>
          <p style={{ textAlign: 'justify' }}>
            Every batch is tracked via RFID or batch coding from collection in color-coded transport bags to final vacuum-sealed delivery.
          </p>

          <div className="service-cta mt-3">
            <a href="/contact" className="btn btn-primary">Contact Us</a>
          </div>
        </div>

        <aside className="service-content-right">
          <div className="image-pair" style={{ marginBottom: '1rem' }}>
            <img src="/laundary_service.jpeg" alt="Laundry" style={{ width: '100%', height: '300px', objectFit: 'cover', marginBottom: '0.5rem', cursor: 'zoom-in' }} onMouseEnter={() => showPreview('/laundary_service.jpeg')} onClick={() => showPreview('/laundary_service.jpeg')} />
            <img src="/industrial_workwear.jpeg" alt="Industrial Workwear" style={{ width: '100%', height: '300px', objectFit: 'cover', cursor: 'zoom-in' }} onMouseEnter={() => showPreview('/industrial_workwear.jpeg')} onClick={() => showPreview('/industrial_workwear.jpeg')} />
          </div>

          <div className="specialty-card">
            <h3>Why Choose Clean World Laundry</h3>
            <ul className="specialty-list">
              <li>Clinically validated processes and documented cycles</li>
              <li>RFID tracking and batch coding for full transparency</li>
              <li>Dual-barrier plant layout preventing cross contamination</li>
              <li>UV-C finishing for an added no-touch safety layer</li>
            </ul>
          </div>
        </aside>
      </section>

      <Review />
    </div>
  );
};

export default LaundryService;
